import { FieldActionProperties, FieldProperties, TableSpec } from 'alurkerja-ui';
import { env } from '@/utils/constants/env';

type IColumn = {
  key: string;
  label: string;
};

type ISpecAttribute = {
  columns: IColumn[];
  title?: string;
  show_detail?: boolean;
};

export const useCustomSpec = (path: string, attr: ISpecAttribute): TableSpec => {
  const makeField = (): { [x: string]: FieldProperties } => {
    const columns = attr.columns;
    const fields: { [x: string]: FieldProperties } = {};

    columns.forEach(({ key, label }, index) => {
      fields[key] = {
        name: key,
        label: label,
        required: true,
        searchable: false,
        filterable: false,
        sortable: true,
        type: 'text',
        form_field_type: 'INPUT_TEXT',
        primary: false,
        is_hidden_in_create: false,
        is_hidden_in_edit: false,
        is_hidden_in_list: false,
        is_hidden_in_detail: false,
        rules: [],
        format: '',
        prefix: '',
        suffix: '',
        list_order: index + 1,
        create_order: index + 1,
        edit_order: index + 1,
      };
    });

    return fields;
  };

  const makeFieldAction = (): FieldActionProperties[] => {
    const fields = [];

    if (attr.show_detail) {
      fields.push({
        label: 'Detail',
        action_label: 'Detail',
        method: 'get',
        form_type: 'modal',
        path: 'detail',
        icon: 'eye',
        type: 'primary',
      });
    }

    return fields;
  };

  return {
    show_as_menu: true,
    name: 'useSpec',
    is_bpmn: false,
    is_usertask: false,
    can_bulk: false,
    can_create: false,
    can_delete: false,
    can_edit: true,
    can_detail: attr.show_detail ?? false,
    label: attr.title ?? '',
    base_url: env.apiBaseUrl,
    path: '-',
    description: 'Field Dari ',
    header_action: [
      {
        label: 'Tambah',
        action_label: 'Tambah',
        method: 'post',
        form_type: 'modal',
        path: '/api/crud/project',
        icon: 'plus',
        type: 'primary',
      },
    ],
    field_action: makeFieldAction(),
    languages: {
      pagination_info: 'Memunculkan data dari {page} sampai {limit} total {total}',
      empty_data: 'Tidak ada data',
      filter_title: 'Filter',
      filter_submit: 'Filter',
      filter_reset: 'Clear Filter',
      filter_cancel: 'Kembali',
    },
    fields: makeField(),
  };
};
